import {
  Checkbox,
  Col,
  Form,
  FormInstance,
  Radio,
  Row,
  Typography,
} from 'antd';
import { useIntl } from 'react-intl';
import ReportSelectMonthFields from '@/components/_common/ReportSelectMonthFields';
import {
  PurchaseAbcCurveDateFilterBy,
  PurchaseAbcCurveFormValues,
  PurchaseAbcCurveImportanceFilterBy,
} from '@/core/domain/NetReport/Purchase/Purchase.types';

interface Props {
  form: FormInstance<PurchaseAbcCurveFormValues>;
}
const AbcCurveReportForm: React.FC<Props> = ({ form }) => {
  const intl = useIntl();
  const { Title } = Typography;

  return (
    <Form layout="vertical" form={form}>
      <ReportSelectMonthFields
        form={form}
        dateFilter={
          <>
            <Title level={5}>
              {intl.formatMessage({
                id: 'purchasesAbcCurveReport.form.filterByDate',
              })}
            </Title>

            <Form.Item
              name="dateFilterBy"
              noStyle
              initialValue={PurchaseAbcCurveDateFilterBy.releaseDate}
            >
              <Radio.Group optionType="button" buttonStyle="solid" size="large">
                <Radio value={PurchaseAbcCurveDateFilterBy.releaseDate}>
                  {intl.formatMessage({
                    id: 'purchasesAbcCurveReport.form.filterByDate.launch',
                  })}
                </Radio>

                <Radio value={PurchaseAbcCurveDateFilterBy.issueDate}>
                  {intl.formatMessage({
                    id: 'purchasesAbcCurveReport.form.filterByDate.emission',
                  })}
                </Radio>
              </Radio.Group>
            </Form.Item>
          </>
        }
      />

      <Row gutter={[16, 8]}>
        <Col sm={24}>
          <Title level={5}>
            {intl.formatMessage({
              id: 'purchasesAbcCurveReport.form.classificationByImportance',
            })}
          </Title>

          <Form.Item
            name="importanceFilterBy"
            noStyle
            initialValue={PurchaseAbcCurveImportanceFilterBy.amount}
          >
            <Radio.Group optionType="button" buttonStyle="solid" size="large">
              <Radio value={PurchaseAbcCurveImportanceFilterBy.amount}>
                {intl.formatMessage({
                  id: 'purchasesAbcCurveReport.form.classificationByImportance.quantity',
                })}
              </Radio>

              <Radio value={PurchaseAbcCurveImportanceFilterBy.value}>
                {intl.formatMessage({
                  id: 'purchasesAbcCurveReport.form.classificationByImportance.value',
                })}
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item
            name="analytical"
            initialValue={false}
            valuePropName="checked"
          >
            <Checkbox>Analítico</Checkbox>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default AbcCurveReportForm;
